import {
    AppBar,
    Badge,
    Box,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    Toolbar,
    Typography
} from "@mui/material";
import {
    AccountCircle,
    CastConnected,
    CastConnectedOutlined,
    Logout,
    MailOutlined,
    Menu as MenuIcon,
    PortableWifiOffOutlined,
    SignalWifiStatusbarConnectedNoInternet4Outlined
} from "@mui/icons-material";
import { useState } from "react";
import useAuth from "hooks/useAuth";
import { useSelector } from "react-redux";
import UserAvatar from "components/common/UserAvatar";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "config";
import { ReadMessages } from "features/Messages/ReadMessages";

function MessageBadge({ messageCount = 0, onClick }) {
    // if (!messageCount) return null;
    return (
        <IconButton
            color="inherit"
            edge="start"
            onClick={onClick}
            sx={{
                mr: 1
                // display: { sm: "none" } // Hides the burger icon on desktop
            }}
        >
            <Badge
                badgeContent={messageCount}
                color="primary"
                invisible={messageCount === 0} // hides badge if count is 0
                sx={{
                    "& .MuiBadge-badge": {
                        fontSize: "0.75rem",
                        minWidth: "18px",
                        height: "18px",
                        borderRadius: "50%"
                    }
                }}
            >
                <MailOutlined />
            </Badge>
        </IconButton>
    );
}

export default function Header({ onMenuClick, drawerWidth = 240 }) {
    const profile = useSelector((state) => state.user.profile);
    const signalRStatus = useSelector((state) => state.message.signalRStatus);
    const myMessages = useSelector((state) => state.message.myMessages);
    const [openMessages, setOpenMessages] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const fullName =
        `${profile?.firstName || ""} ${profile?.lastName || ""}`.trim();
    const { logout } = useAuth();

    const handleUserMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setAnchorEl(null);
    };

    // const photo = profile?.photoFileName;

    const renderStatus = () => {
        return (
            <Badge
                sx={{
                    color:
                        signalRStatus === "Connected"
                            ? "rgb(132 179 132)"
                            : signalRStatus === "Reconnecting"
                              ? "orange"
                              : "red"
                }}
            >
                {signalRStatus === "Connected" ? (
                    <Box
                        sx={{
                            "@keyframes pulse": {
                                "0%": {
                                    transform: "scale(1)",
                                    opacity: 1
                                },
                                "50%": {
                                    transform: "scale(1.2)",
                                    opacity: 0.7
                                },
                                "100%": {
                                    transform: "scale(1)",
                                    opacity: 1
                                }
                            },
                            animation: "pulse 1.5s infinite ease-in-out",
                            display: "inline-flex"
                        }}
                    >
                        <CastConnectedOutlined />
                    </Box>
                ) : signalRStatus === "Reconnecting" ? (
                    <Box
                        sx={{
                            "@keyframes spin": {
                                "0%": { transform: "rotate(0deg)" },
                                "100%": { transform: "rotate(360deg)" }
                            },
                            animation: "spin 1.2s linear infinite",
                            display: "inline-flex"
                        }}
                    >
                        <SignalWifiStatusbarConnectedNoInternet4Outlined />
                    </Box>
                ) : (
                    <PortableWifiOffOutlined />
                )}
            </Badge>
        );
    };

    return (
        <AppBar
            position="fixed"
            elevation={1}
            // We apply the layout spacing directly here using modern sx prop
            sx={(theme) => {
                return {
                    width: "100%", // Full width left-to-right on all screens
                    ml: 0,
                    zIndex: (theme) => theme.zIndex.drawer + 1, // Forces it visually on top of the sidebar
                    backgroundColor: theme?.palette?.official?.main
                };
            }}
        >
            <Toolbar>
                <IconButton
                    color="inherit"
                    edge="start"
                    onClick={onMenuClick}
                    sx={{
                        mr: 2,
                        display: { sm: "none" } // Hides the burger icon on desktop
                    }}
                >
                    <MenuIcon />
                </IconButton>

                <Typography
                    variant="h6"
                    noWrap
                    sx={(theme) => ({
                        flexGrow: 1,
                        color: theme?.palette?.official?.light
                    })}
                >
                    Design Center of The Philippines
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    }}
                >
                    <MessageBadge
                        messageCount={myMessages?.length}
                        onClick={() => setOpenMessages(true)}
                    />
                    {renderStatus()}
                    <IconButton onClick={handleUserMenuOpen} color="inherit">
                        <UserAvatar />
                    </IconButton>
                    <Box
                        sx={{
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        }}
                    >
                        <Typography variant="body2">{fullName}</Typography>
                    </Box>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleUserMenuClose}
                    >
                        <MenuItem
                            onClick={() => {
                                handleUserMenuClose();
                                navigate(ROUTES.MY_PROFILE);
                            }}
                        >
                            <ListItemIcon>
                                <AccountCircle fontSize="small" />
                            </ListItemIcon>
                            Profile
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleUserMenuClose();
                                logout();
                            }}
                        >
                            <ListItemIcon>
                                <Logout fontSize="small" />
                            </ListItemIcon>
                            Logout
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
            <ReadMessages
                open={openMessages}
                onClose={() => setOpenMessages(false)}
            ></ReadMessages>
        </AppBar>
    );
}
